var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons 24 px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bitcoin-(btc)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 22.5C17.5228 22.5 22 18.0228 22 12.5C22 6.97715 17.5228 2.5 12 2.5C6.47715 2.5 2 6.97715 2 12.5C2 18.0228 6.47715 22.5 12 22.5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6323 15.3204C15.6323 15.5966 15.8561 15.8204 16.1323 15.8204H16.5C16.7761 15.8204 17 15.5966 17 15.3204V8.85267C16.9998 8.80086 16.9794 8.75124 16.9433 8.7146C16.9072 8.67797 16.8583 8.6573 16.8071 8.65709H13.9362C13.8892 8.65719 13.8438 8.67448 13.8084 8.70579L12.3904 9.96958C12.3687 9.92324 12.3462 9.8769 12.3207 9.83213C12.1812 9.58005 12.0005 9.35547 11.7876 9.1673C11.6547 9.04988 11.5092 8.94664 11.3534 8.85974C10.9344 8.62175 10.4255 8.5 9.84004 8.5H9.81603C9.23053 8.5 8.72093 8.62175 8.30349 8.85974C7.89681 9.08618 7.56129 9.42428 7.33541 9.83527C7.11238 10.2438 6.99688 10.7036 7.00006 11.1705V15.3243C7.00006 15.6005 7.22392 15.8243 7.50006 15.8243H7.81666C8.0928 15.8243 8.31666 15.6005 8.31666 15.3243V11.1705C8.31435 10.9722 8.35129 10.7755 8.42531 10.592C8.49933 10.4084 8.60891 10.2418 8.74757 10.102C8.88623 9.96217 9.05114 9.85199 9.23254 9.77798C9.41394 9.70397 9.60814 9.66763 9.80364 9.67111H9.85166C10.1118 9.66657 10.3685 9.73271 10.5949 9.86267C10.8214 9.99264 11.0094 10.1817 11.1396 10.4102C11.2718 10.641 11.34 10.9037 11.3371 11.1705V15.3243C11.3371 15.6005 11.5609 15.8243 11.8371 15.8243H12.1537C12.4298 15.8243 12.6537 15.6005 12.6537 15.3243V11.694C12.6537 11.5514 12.7146 11.4155 12.8211 11.3207L15.2327 9.17235C15.2674 9.14144 15.3102 9.12133 15.356 9.11443C15.4017 9.10752 15.4484 9.11411 15.4906 9.13341C15.5327 9.15271 15.5685 9.1839 15.5936 9.22325C15.6187 9.26261 15.6322 9.30847 15.6323 9.35536V15.3204ZM16.8032 8.85267L16.8025 8.85338Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMCoin);
export default __webpack_public_path__ + "static/media/m-coin.2b670e63d3e595beb2367054a3fcbc8f.svg";
export { ForwardRef as ReactComponent };